var IREP = IREP || {};

IREP.SWIC6Desktop = (function () {
    var defaultOptions = {
        mode: 'desktop',
        firstVisit: false
    };
    var SWIC6Desktop = function (options) {
        var self = this;

        this.options = $.extend({}, defaultOptions, options);
        IREP.SWIC6.call(this, this.options);

        this.individualProfile = { participants: ko.observableArray() };
        ko.applyBindings(this.individualProfile, $('#individualProfile')[0]);

        this.personalProfile = { profile: ko.observable() };
        this.numOfLearnings = { learnings: ko.observable() };
        //ko.applyBindings({ personalProfile: this.personalProfile, numOfLearnings: this.numOfLearnings }, $('#myPersonalInfo')[0]);

        this.storeProfile = { storeProfile: ko.observable() };
        this.manager = { manager: ko.observable() };

        this.schools = { schools: ko.observable() };

        this.mysteryShop = { mysteryShop: ko.observable() };
        
        ko.applyBindings({ storeProfile: this.storeProfile, manager: this.manager, mysteryShop: this.mysteryShop, schools: this.schools }, $('#storeInfo')[0]);


        ko.applyBindings({ storeProfile: this.storeProfile }, $('#msleaderboard')[0]);


        //ko.applyBindings({ storeProfile: this.storeProfile, manager: this.manager, mysteryShop: this.mysteryShop }, $('#storeInfo2')[0]);

        this.storeDashboard = { dashboard: ko.observableArray() };

        this.voteForSchool = function (id) {

            if (id !== undefined) {
                IREP.callApi({
                    url: "swic6/schoolvote",
                    type: "POST",
                    data: { schoolId: id.id }
                }).then(function () {
                    return self.getSchoolNominations();
                }).then(function (school) {
                    self.updateSchoolNominations(school);
                });

                if ($('.box').hasClass('selected') !== true) {
                    $('a').removeClass('onHover');
                    $('.fullInfoBlock').addClass('doNotShow');
                    $('.votes').removeClass('doNotShow');

                    var targetElement = event.currentTarget;
                    $(targetElement).addClass('selected');
                }
            }
        };

        this.totalNumOfVotes = { totalNumOfVotes: ko.observable() };

        //ko.applyBindings({ schools: this.schools, dashboard: this.storeDashboard, voteForSchool: this.voteForSchool, totalNumOfVotes: this.totalNumOfVotes }, $('#dashboard')[0]);

        this.storeLeaderboard = { leaderboard: ko.observableArray() };
        //ko.applyBindings(this.storeLeaderboard, $('#leaderboard')[0]);



        this.setupOnce();
    }

    SWIC6Desktop.prototype = Object.create(IREP.SWIC6.prototype);
    SWIC6Desktop.prototype.constructor = SWIC6Desktop;

    SWIC6Desktop.prototype.setupOnce = function () {
        var self = this;

        $("#footer").remove();

        self.showInitialView();

        $('#home-svg').off().on('touchstart click', '[data-nav]', function (e) {
            var navitem = $(this).data('nav');
            self.switchNav(navitem);

            e.stopPropagation();
            e.preventDefault();
            return false;
        });



        $('nav').off().on('touchstart click', '[data-nav]', function (e) {
            if (self.navEnabled) {
                var navitem = $(this).data('nav');

                self.toggleNav(false);

                if (navitem === 'story' && self.selectedPage === 'sb-item') { /* This is so users can navigate from one storyboard section to the other */
                    self.switchNav(navitem, true);
                    e.stopPropagation();
                    e.preventDefault();
                    self.toggleNav(true);
                    return false;
                };

                var navSelector = navitem === 'recon' ? $('#board') : $('#' + navitem); //This is to prevent nav from breaking when on the recon page and clicking recon, since recon isn't in #recon
                if (navSelector.is(':visible')) {
                    e.stopPropagation();
                    e.preventDefault();
                    self.toggleNav(true);
                    return false;
                };

                self.switchNav(navitem, true);

                e.stopPropagation();
                e.preventDefault();
            }

            return false;
        });

        $('.home-story').on('click', function () {
            self.closeDoor();
            
        });

        $('.nominateSchool').on('click', function () {
            self.switchNav('manager');
        });

        $('.notVerifiedManager').on('click', function () {
            self.switchNav('manager');
        });

        $('.btnNext').on('click', function () {
            self.switchNav('overview');
        });

        $('.storeDashboardLink').on('click', function () {
            self.switchNav('leaderboards');
        });

        $('.DashboardLink').on('click', function () {
            $('#overview').addClass('switchToDashboard');
            self.switchNav('leaderboards');
        });

        $('.LeaderboardLink').on('click', function () {
            $('#overview').addClass('switchToLeaderboard');
            self.switchNav('leaderboards');
        });

        $('.prizesLink').on('click', function () {
            self.switchNav('prizes');
        });

        $('#garagePopup').on('click', function () {
            $('#garagePopup').fadeOut(800);
        });


        $("nav > div > img").on("mouseover", function () {
            this.parentNode.children[0].style.display = "none";
            this.parentNode.children[1].style.display = "block";
            this.parentNode.children[2].style.display = "block";

        });

        $("nav > div > img").on("mouseout", function () {
            this.parentNode.children[0].style.display = "block";
            this.parentNode.children[1].style.display = "none";
            this.parentNode.children[2].style.display = "none";
        });

        $("#nav-lb > div > img").on("mouseover", function () {
            this.parentNode.children[0].style.display = "none";
            this.parentNode.children[1].style.display = "block";
            this.parentNode.children[2].style.display = "block";

        });

        $("#nav-lb > div > img").on("mouseout", function () {
            if (this.parentElement.className.indexOf('active') > -1) {
                this.parentNode.children[0].style.display = "none";
                this.parentNode.children[1].style.display = "block";
                this.parentNode.children[2].style.display = "none";
            }
            else {
                this.parentNode.children[0].style.display = "block";
                this.parentNode.children[1].style.display = "none";
                this.parentNode.children[2].style.display = "none";
            }
        });

        if ($('#navProfile').hasClass('active') === true) {
            $('.profileActive').show();
            $('.profileInactive').hide();
        };

        $('#navProfile').one('click', function () {
            self.navProfileClick(false);
        });

        $('#navDashboard').one('click', function () {
            self.navDashboardClick();
        });

        $('#navLeaderboard').one('click', function () {
            self.navLeaderboardClick();
        });

        $('.transmission-pages').keydown(function (e) {
            var parentDiv = $(this).parent().attr('id');

            switch (e.which) {
                case 37:
                    self.comicPreviousSlide(parentDiv);
                    break;
                case 39:
                    self.comicNextSlide(parentDiv);
                    break;
                default:
                    break;
            };
        });
        /************************
        * Win it Minute Tracking
        ************************/


        //videojs("video_01Landing").ready(function () {
        //    this.on("ended", function () {

        //        IREP.track("WinItMinute", "ended", 'WinItMinuteEnded', '', '');
        //    });
        //    this.on("play", function () {
        //        IREP.track("WinItMinute", "played", 'WinItMinutePlay', '', '');
        //    });

        //    this.on("loadstart", function () {
        //        IREP.track("WinItMinute", "started", 'WinItMinuteStarted', '', '');

        //    });
        //});

    };

    SWIC6Desktop.prototype.showInitialView = function () {
        var self = this;
        if (self.options.firstVisit) {
            $('#storyline').fadeIn(400);
        } else if (window.location.hash !== "") {
            self.switchNav(window.location.hash.substring(1));
        } else {
            self.switchNav("home");
        }
    };

    SWIC6Desktop.prototype.selectedPage = '';
    SWIC6Desktop.prototype.navEnabled = true;

    SWIC6Desktop.prototype.toggleNav = function (enabled) {
        this.navEnabled = enabled;
    };

    SWIC6Desktop.prototype.switchNav = function (navitem, opendoor) {
        var self = this;

        if ($('#garagePopup').hasClass('seen')) {
            $('#garagePopup').hide();
        }

        navitem = navitem.toLowerCase();
        var possibleNavItems = ['home', 'story', 'leaderboards', 'recon', 'learn', 'garage', 'prizes', 'overview', 'manager', 'winners'];
        if (_.all(possibleNavItems, function (e) { return e !== navitem })) {
            navitem = 'home';
        }

        //if (self.selectedPage === 'garage') self.selectedPage = 'home';

        if (self.selectedPage == navitem) return;

        $('nav').removeClass().addClass(navitem);

        this.trackNavigation(navitem);

        var waitToLoad = ko.observable(false);

        var goToPage = function (value) {
            if (!value) {
                $('.glowFrame').hide();

                if (navitem == "story") {

                    self.resetStoryboard();
                    
                    $('.page').hide();
                    $("#left-navigation, #right-navigation").hide();
                    self.fastCloseDoor().then(function () {
                        $('#' + navitem).show();
                        $("#left-navigation, #right-navigation").fadeIn();
                        self.toggleNav(true);
                    });
                } else {
                    $(".page").fadeOut();
                    $("#" + navitem).fadeIn();
                    $("#SWIC6").removeClass();
                    $("#SWIC6").addClass(navitem);

                    switch (navitem) {
                        case "home":
                            
                            //self.showItemPopup();


                            break;
                        case "leaderboards":
                            self.hideMoon();
                            self.showGroupLeaderboards();
                            $('.glowFrame').show();
                            if ($('#overview').hasClass('switchToDashboard')) {
                                $('#overview').hasClass('switchToDashboard')
                                //self.navDashboardClick();
                                self.showGroupLeaderboards();
                            }
                            else if ($('#overview').hasClass('switchToLeaderboard')) {
                                $('#overview').removeClass('switchToLeaderboard');
                                //self.navLeaderboardClick();
                                self.showGroupLeaderboards();
                            }
                            else {
                                // self.navProfileClick(true);
                                self.showGroupLeaderboards();
                            }
                            break;
                        case "learn":
                            
                            $('.glowFrame').show();
                            // self.activateIndividualProfile();
                            break;
                        case "overview":
                            
                            $('.glowFrame').show();
                            self.hideMoon();
                            self.showMysteryShop();
                            break;
                        case "prizes":
                            
                            $('.glowFrame').show();
                            self.hideMoon();
                            break;
                        case "winners":
                            $('.glowFrame').show();
                            self.hideMoon();
                            
                            break;
                        case "manager":
                            
                            self.showManager();
                        default:
                            break;
                 

                    }

                    self.toggleNav(true);
                }
            }
        };

        waitToLoad.subscribe(goToPage);

        waitToLoad(true);
        switch (self.selectedPage) {
            case 'home':
                waitToLoad(false);
                break;
            case 'story':
                
                $("#left-navigation, #right-navigation").hide();

                self.hideStoryboard().then(function () {
                    waitToLoad(false);
                });

                break;
            case 'leaderboards':
                self.hideLeaderboard();
                self.showGroupLeaderboards();
                self.hideMoon();
                waitToLoad(false);
                break;
            case 'recon':
                self.hideReconBoard();
                waitToLoad(false);
                //self.fastOpenDoor().then(function () {
                   
               // });
                break;
            case 'learn':
                waitToLoad(false);
                break;
            case 'prizes':
                self.hideMoon();
                waitToLoad(false);
                break;
            case 'winners':
                self.hideMoon();
                waitToLoad(false);
                break;
            case 'overview':
                self.hideMoon();
                self.showMysteryShop();
                waitToLoad(false);
                break;
            case 'sb-item':
                $('.door').hide();
                $('#transmission1, #transmission2, #transmission3, #transmission1-pages, #transmission2-pages, #transmission3-pages').hide();
                self.resetLockNav();

                if ($('.sb-doors').is(':visible')) {
                    $('.sb-panel0, .sb-panel1, .sb-panel2, .sb-panel3, .sb-panel4, .sb-panel5, .sb-panel6, .sb-panel7').addClass('sb-open');
                    setTimeout(function () {
                        $('.sb-doors').hide();
                        waitToLoad(false);
                    }, 3200)
                } else {
                    waitToLoad(false);
                }
                break;
            default:
                waitToLoad(false);
                break;
        };

        self.selectedPage = navitem;
    };

    SWIC6Desktop.prototype.navProfileClick = function (forceProfile) {
        var self = this;

        if ($('#navProfile').hasClass('active') === false || forceProfile === true) {
            self.trackLeaderboard('profile');

            //self.showIndividualProfile();

            $('#navDashboard').removeClass('active');
            $('#navLeaderboard').removeClass('active');
            $('#navProfile').addClass('active');

            $('.profileActive').show();
            $('.profileInactive').hide();
            $('.dashboardActive').hide();
            $('.dashboardInactive').show();

            $('.leaderboardActive').hide();
            $('.leaderboardInactive').show();

            $('#storeDashboard').hide();
            $('#storeLeaderboard').hide();
            $('.lb-dashboard').hide();
            $('.lb-leaderboard').hide();
            $('.lb-profile').show();
            $('#personalInfo').show();

            $('#navProfile').one('click', function () {
                self.navProfileClick();
            });
        };
    };

    SWIC6Desktop.prototype.navDashboardClick = function () {
        var self = this;

        if ($('#navDashboard').hasClass('active') === false) {
            //self.trackLeaderboard('dashboard');
            //self.showStoreDashboard();

            $('#navProfile').removeClass('active');
            $('#navLeaderboard').removeClass('active');
            $('#navDashboard').addClass('active');

            $('.profileActive').hide();
            $('.profileInactive').show();


            $('.dashboardActive').show();
            $('.dashboardInactive').hide();

            $('.leaderboardActive').hide();
            $('.leaderboardInactive').show();

            $('#personalInfo').hide();
            $('#storeLeaderboard').hide();
            $('.lb-profile').hide();
            $('.lb-leaderboard').hide();
            $('.lb-dashboard').show();
            $('#storeDashboard').show();

            $('#navDashboard').one('click', function () {
                self.navDashboardClick();
            });
        };
    };

    SWIC6Desktop.prototype.navLeaderboardClick = function () {
        var self = this;

        if ($('#navLeaderboard').hasClass('active') === false) {
            //self.trackLeaderboard('leaderboard');
            //self.showStoreLeaderboard();
            self.showGroupLeaderboards();
            $('#navProfile').removeClass('active');
            $('#navDashboard').removeClass('active');
            $('#navLeaderboard').addClass('active');

            $('.profileActive').hide();
            $('.profileInactive').show();

            $('.dashboardActive').hide();
            $('.dashboardInactive').show();

            $('.leaderboardActive').show();
            $('.leaderboardInactive').hide();

            $('#storeDashboard').hide();
            $('#personalInfo').hide();
            $('.lb-dashboard').hide();
            $('.lb-profile').hide();
            $('.lb-leaderboard').show();
            $('#storeLeaderboard').show();

            $('#navLeaderboard').one('click', function () {
                self.navLeaderboardClick();
            });
        };
    };

    SWIC6Desktop.prototype.animateRings = function () {
        var oldFill = '#58595B';
        var loadFill = '#FFF';
        $('[class^=ring]').css('fill', oldFill)
        var i = 10;
        this.animateRingsIntervalID = setInterval(function () {
            var old = i + 1;
            if (old > 10) {
                old = 0;
            }

            $('.ring' + old).css('fill', oldFill);
            $('.ring' + i).css('fill', loadFill);
            i--;
            if (i < 0) {
                i = 10;
            }
        }, 100);
    };

    SWIC6Desktop.prototype.showMoon = function () {
        var self = this;
        var deferred = $.Deferred();

        $('#moon-svg').css('opacity', '1').show();

        self.animateRings();
        this.delay(2000).then(function () {
            deferred.resolve();
        });

        return deferred.promise();
    }

    SWIC6Desktop.prototype.hideMoon = function () {
        var self = this;
        var deferred = $.Deferred();

        $('#moon-svg').css('opacity', '0');

        this.delay(2000).then(function () {
            clearInterval(self.animateRingsIntervalID);
            $('#moon-svg').hide();

            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6Desktop.prototype.hideLeaderboard = function () {
        var self = this;
        var deferred = $.Deferred();

        $('.lb-mainBody').hide();
        deferred.resolve();
        return deferred.promise();
    };

    SWIC6Desktop.prototype.showLeaderboard = function () {
        var self = this;

        self.hideMoon().then(function () {
            $('.lb-mainBody').fadeIn(300);
            self.showGroupLeaderboards();
        });
    };


    /************************
   *        OverView
   ************************/

    //MYSTERY SHOP STORE CODE
    SWIC6Desktop.prototype.showMysteryShop = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/store/level",
            type: "GET"
        }).done(function (response) {
            if (response.storeLevel === "GroupA" || response.storeLevel === "Elite") {
                //Mystery Shop Store
                //console.log('I get mystery shops');
                $(".mysteryShop").show();

            } else {
                //Non Mystery Shop Store 
                //console.log('I\'m a sad panda and do not get mysery shop');
                $(".NonMysteryShop").show();

            }
        });
    };


    //END MYSTERY SHOP STORE CODE


    SWIC6Desktop.prototype.showGroupLeaderboards = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/store/level",
            type: "GET"
        }).done(function (response) {
            console.log(response);
            if (response.storeLevel === "Elite") {
                //Mystery Shop Store
                //console.log('I get mystery shops');
                $("#eliteStoreWinners").css("display", "block");

            } else if (response.storeLevel === "GroupA") {
                //Non Mystery Shop Store 
                //console.log('I\'m a sad panda and do not get mysery shop');
                $("#groupAStoreWinners").css("display", "block");

            }
            else if (response.storeLevel === "GroupB") {
                $("#groupBStoreWinners").css("display", "block");
            }
        });
    };


   

    /************************
    * Manager
    ************************/

    SWIC6Desktop.prototype.showManager = function () {
        var self = this;

        IREP.swic6Registration = new IREP.SWIC6EarlyRegistration();

        $(".glowFrame").show();
        self.hideMoon();
        self.toggleNav(true);
    }


    /************************
    * Garage Item Popup 
    ************************/

    SWIC6Desktop.prototype.getItemPopup = function () {
        var self = this;
        return IREP.callApi({ url: 'swic6/popup' })

    };

    SWIC6Desktop.prototype.showItemPopup = function () {
        var self = this;

        $.when(this.getItemPopup()).then(function (popup) {
            if (popup.item !== undefined) {
                $('#garagePopup').show();
                document.getElementById("itemName").innerHTML = popup.item.name;
                if (popup.item.typeid === 7) {
                    document.getElementById("itemImage").src = "/content/images/asmo/2015swic/garage/tools/" + popup.item.icon;
                }
                else {
                    document.getElementById("itemImage").src = "/content/images/asmo/2015swic/garage/parts/" + popup.item.icon;
                }

                $('#garagePopup').addClass('seen');
                self.updateItemPopup(popup.item.id);
            }
        });
    };

    SWIC6Desktop.prototype.updateItemPopup = function (id) {
        var self = this;
        IREP.callApi({
            url: "swic6/popup/update",
            type: "POST",
            data: { itemId: id }
        }).done();
    };

    /************************
    * Individual Profile
    ************************/


    SWIC6Desktop.prototype.showIndividualProfile = function () {
        var self = this;
        
        $.when(this.getIndividualProfile(), this.getIndividualLeaderboard(), this.getNumOfLearnings(), this.hideLeaderboard(), this.showMoon()).then(function (individual, individualinfo, numOfLeanings) {
            self.personalProfile.profile(individual[0].info);
            self.individualProfile.participants(individualinfo[0].leaderboard);
            
            self.numOfLearnings.learnings(numOfLeanings[0]);

            $("#redeemToken").off().one("click", function () {
                self.trackLeaderboard('token');
                self.getTokenRedemption();
            });

            return self.showLeaderboard();
        });

    };

    SWIC6Desktop.prototype.getTokenRedemption = function () {
        var deferred = $.Deferred();
        var self = this;

        IREP.callApi({
            url: "swic6/redeemtoken"
        }).done(function (d) {
            if (d.info) {

                $("#weeklyDrawingEntries").html("+" + d.info.randomEntries);
                setTimeout(function () { $("#weeklyDrawingEntries").html(d.info.drawingEntries); }, 2000);
                $("#tokensAvailable").html(d.info.availableTokens);

                if (d.info.availableTokens > 0) {
                    $("#redeemToken").off().one("click", function () {
                        self.trackLeaderboard('token');
                        self.getTokenRedemption();
                    });
                } else {
                    $("#redeemToken").parent().hide();
                }
            }

            deferred.resolve();
        });

        return deferred.promise();
    };


    SWIC6Desktop.prototype.getIndividualProfile = function () {
        return IREP.callApi({ url: 'swic6/individualinfo' })
    };

    SWIC6Desktop.prototype.getIndividualLeaderboard = function () {
        return IREP.callApi({ url: 'swic6/individual' });
    };

    SWIC6Desktop.prototype.getNumOfLearnings = function () {
        return IREP.callApi({ url: 'swic6/numOfLearnings' });
    };
    /************************
     * Store Dashboard
     ************************/

    SWIC6Desktop.prototype.getManagerInfo = function () {
        return IREP.callApi({ url: 'swic6/managerinfo' });
    };

    SWIC6Desktop.prototype.getStoreProfile = function () {
        return IREP.callApi({ url: 'swic6/storeinfo' })
    };

    SWIC6Desktop.prototype.getStoreDashboard = function () {
        return IREP.callApi({ url: 'swic6/dashboard' });
    };

    SWIC6Desktop.prototype.getMysteryShop = function () {
        return IREP.callApi({ url: 'swic6/mysteryshop' });
    };

    SWIC6Desktop.prototype.getSchoolNominations = function () {
        return IREP.callApi({ url: 'swic6/nominations' });
    };

    SWIC6Desktop.prototype.showStoreDashboard = function () {
        var self = this;
        $.when(this.getStoreProfile(), this.getManagerInfo(), this.getStoreDashboard(), this.getMysteryShop(), this.getSchoolNominations(), this.hideLeaderboard(), this.showMoon()).then(function (storeProfile, managerInfo, storeDashboard, mysteryShop, schools) {
            self.storeProfile.storeProfile(storeProfile[0].info);
            self.manager.manager(managerInfo[0].info);
            self.mysteryShop.mysteryShop(mysteryShop[0].mysteryShopDetail);
            self.storeDashboard.dashboard(storeDashboard[0].dashboard);
            self.updateSchool(schools);
        });
    };

    SWIC6Desktop.prototype.updateSchool = function (schoolInfo) {
        var self = this;
        self.schools.schools(schoolInfo[0].noms)

        var totalVotes = 0;
        for (var i = 0; i < schoolInfo[0].noms.length; i++) {
            totalVotes = schoolInfo[0].noms[i].votes + totalVotes;
        }

        self.totalNumOfVotes.totalNumOfVotes(totalVotes);

        if (schoolInfo[0].noms.length < 2) {
            $('#dashboard .dashboardTbody').css('height', '420px');
        };

        if (schoolInfo[0].noms.length >= 5) {
            $('#storeInfo tbody').css('height', '420px');
            $('#storeInfo tfoot').addClass('doNotShow');
            $('#leaderboards .lb-mainBody #column1 tbody').css('height', '100%');
            $('#leaderboards .lb-mainBody #column2 tbody').css('height', '100%');
        };

        return self.showLeaderboard();
    };

    SWIC6Desktop.prototype.updateSchoolNominations = function (schoolInfo) {
        var self = this;
        self.schools.schools(schoolInfo.noms)

        var totalVotes = 0;
        for (var i = 0; i < schoolInfo.noms.length; i++) {
            totalVotes = schoolInfo.noms[i].votes + totalVotes;
        }

        self.totalNumOfVotes.totalNumOfVotes(totalVotes);
        return self.showLeaderboard();
    }

    /***********************
    * Store Leaderboard
    **********************/

    SWIC6Desktop.prototype.showStoreLeaderboard = function () {
        var self = this;
        $.when(this.getStoreProfile(), this.getStoreLeaderboard(), this.getManagerInfo(), this.getMysteryShop(), this.hideLeaderboard(), this.showMoon()).then(function (storeProfile, storeLeaderboard, managerInfo, mysteryShop) {

            self.storeProfile.storeProfile(storeProfile[0].info);
            self.manager.manager(managerInfo[0].info);
            self.mysteryShop.mysteryShop(mysteryShop[0].mysteryShopDetail);
            self.storeLeaderboard.leaderboard(storeLeaderboard[0].leaderboard);
            return self.showLeaderboard();
        });
    };

    SWIC6Desktop.prototype.getStoreLeaderboard = function () {
        return IREP.callApi({ url: 'swic6/storeleaderboard' });
    };

    SWIC6Desktop.prototype.openDoor = function () {
        var self = this;
        var deferred = $.Deferred();

        $('.door').show();
        $('.s3lock').addClass('open');
        this.delay(1000).then(function () {
            $('.panel0').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel1').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel2').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel3').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel4').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel5').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel6').addClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel7').addClass('open');
            return self.delay(3000);
        }).then(function () {
            $('.door').hide();
            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6Desktop.prototype.fastOpenDoor = function () {
        var self = this;

        var deferred = $.Deferred();

        $('.door').show();
        this.delay(0).then(function () {
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');
            return self.delay(3000);
        }).then(function () {
            $('.door').hide();
            deferred.resolve();
        });

        return deferred.promise();
    }

    SWIC6Desktop.prototype.closeDoor = function () {
        var self = this;
        var deferred = $.Deferred();

        $('.door').show();

        this.delay(0).then(function () {
            $('.panel0').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel1').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel2').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel3').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel4').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel5').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel6').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.panel7').removeClass('open');
            return self.delay(1000);
        }).then(function () {
            $('.s3lock').removeClass('open');
            return self.delay(3000);
        }).then(function () {
            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6Desktop.prototype.fastCloseDoor = function () {
        var self = this;

        var deferred = $.Deferred();

        $('.door').show();
        this.delay(30).then(function () {
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').removeClass('open');
            return self.delay(3030);
        }).then(function () {
            deferred.resolve();
        });

        return deferred.promise();
    };

    /******************
     * Recon
     ******************/

    SWIC6Desktop.prototype.showReconBoard = function (recons) {
        var self = this;
        $('#board, #board img').hide();
        $('.sb-wrapper').hide();

        this.hideMoon().then(function () {
            //return self.fastCloseDoor();
        }).then(function () {
            $('#board').show();

            self.toggleNav(true);

            //self.setupReconBoard(recons);

            $('#board [data-available]').off();
            $('#board [data-available=true]').off().on('click', function () {
                var quizType = $(this).data('quiztype');
                var reconUID = $(this).data('uid');

                //self.fastOpenDoor();
                self.startReconInstructions(quizType, reconUID);
            });
        });
    };

    SWIC6Desktop.prototype.setupReconBoard = function (recons) {
        $.each(recons, function (i, e) {
            var $element = $('.' + e.location);

            $element.attr('data-quiztype', e.type).data('quiztype', e.type);
            $element.attr('data-available', e.available).data('available', e.available);
            $element.attr('data-uid', e.uid).data('uid', e.uid);

            if (e.available) {
                $element.show();
            } else {
                $element.attr('data-quiztype', '');
            }
        });
    };

    SWIC6Desktop.prototype.hideReconBoard = function () {
        var self = this;

        //self.fastOpenDoor();
        $('#board').hide();
        $('.sb-wrapper').show();
    };

    /******************
     * Story
     ******************/

    SWIC6Desktop.prototype.hideStoryboard = function () {
        var self = this;

        var deferred = $.Deferred();

        $('.sb-panel0, .sb-panel1, .sb-panel2, .sb-panel3, .sb-panel4, .sb-panel5, .sb-panel6, .sb-panel7').removeClass('sb-open');
        self.fastOpenDoor().then(function () {
            
            self.resetLockNav();
            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6Desktop.prototype.resetLockNav = function () {
        $('#left-navigation > .nav-1 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#left-navigation > .nav-2 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#left-navigation > .nav-3 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#left-navigation > .nav-4 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#right-navigation > .nav-1 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#right-navigation > .nav-2 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#right-navigation > .nav-3 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
        $('#right-navigation > .nav-4 > .default-nav > img').attr('src', '/content/images/asmo/2015swic/desktop/nav-gray-2.png').off().removeClass('pointer-cursor');
    };

    SWIC6Desktop.prototype.resetStoryboard = function () {
        var self = this;

        //Show the storyboard nav circles
        var videoEvent = $('#left-navigation > .nav-1 > .default-nav > img');
        var storyline = $('#left-navigation > .nav-2 > .default-nav > img');
        var crewLogButton = $('#left-navigation > .nav-3 > .default-nav > img');
        var trans1button = $('#left-navigation > .nav-4 > .default-nav > img');
        var trans2button = $('#right-navigation > .nav-1 > .default-nav > img');
        var trans3button = $('#right-navigation > .nav-2 > .default-nav > img');

        //Setup Video Event
        videoEvent.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightgray.png').addClass('pointer-cursor');
        videoEvent.hover(function () {
            videoEvent.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightgray-hover.png')
        }, function () {
            videoEvent.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightgray.png')
        });
        videoEvent.on("click", function () {
            window.location = window.location.origin + IREP.options.appUrl + 'asmo/quiz?code=201505vid_SWIC6VideoEvent';
        });


        //Setup Storyline
        storyline.attr('src', '/content/images/asmo/2015swic/desktop/nav-yellow.png').addClass('pointer-cursor');
        storyline.hover(function () {
            storyline.attr('src', '/content/images/asmo/2015swic/desktop/nav-yellow-hover.png')
        }, function () {
            storyline.attr('src', '/content/images/asmo/2015swic/desktop/nav-yellow.png')
        });
        storyline.on("click", function () {
            $('.door, #story').fadeOut();
            
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');

            $('#storyline').fadeIn(400);
        });


        // Setup crew log button
        crewLogButton.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightestblue-2.png').addClass('pointer-cursor');
        crewLogButton.hover(function () {
            crewLogButton.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightestblue-hover-2.png')
        }, function () {
            crewLogButton.attr('src', '/content/images/asmo/2015swic/desktop/nav-lightestblue-2.png')
        });
        crewLogButton.on('click', function () {
            $("#left-navigation, #right-navigation").hide();
            self.trackStory('crew-log');
            self.selectedPage = 'sb-item';

            //Adds the "open" class to all panels. Using this, instead of the OpenDoors function, so that they open simultaneously
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');

            //Pulls down the doors with the labels on them for the crew log
            setTimeout(function () {
                $('.door').hide();
                $('.sb-panel0, .sb-panel1, .sb-panel2, .sb-panel3, .sb-panel4, .sb-panel5, .sb-panel6, .sb-panel7').removeClass('sb-open');
            }, 2700);
        });

        // Setup transmission 1 button
        trans1button.attr('src', '/content/images/asmo/2015swic/desktop/nav-mediumblue-2.png').addClass('pointer-cursor');
        trans1button.hover(function () {
            trans1button.attr('src', '/content/images/asmo/2015swic/desktop/nav-mediumblue-hover-2.png')
        }, function () {
            trans1button.attr('src', '/content/images/asmo/2015swic/desktop/nav-mediumblue-2.png')
        });
        trans1button.on('click', function () {
            $("#left-navigation, #right-navigation").hide();
            self.trackStory('transmission1');
            self.selectedPage = 'sb-item';

            self.ShowComic('transmission1');

            //Adds the "open" class to all panels. Using this, instead of the OpenDoors function, so that they open simultaneously
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');
        });

        // Setup transmission 2 button
        trans2button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-orange-2.png').addClass('pointer-cursor');
        trans2button.hover(function () {
            trans2button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-orange-hover-2.png')
        }, function () {
            trans2button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-orange-2.png')
        });
        trans2button.on('click', function () {
            self.trackStory('transmission2');
            self.selectedPage = 'sb-item';

            self.ShowComic('transmission2');

            //Adds the "open" class to all panels. Using this, instead of the OpenDoors function, so that they open simultaneously
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');
        });

        // Setup transmission 3 button
        trans3button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-pink-2.png').addClass('pointer-cursor');
        trans3button.hover(function () {
            trans3button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-pink-hover-2.png')
        }, function () {
            trans3button.attr('src', '/content/images/asmo/2015swic/desktop/nav-recon-pink-2.png')
        });
        trans3button.on('click', function () {
            self.trackStory('transmission3');
            self.selectedPage = 'sb-item';

            self.ShowComic('transmission3');

            //Adds the "open" class to all panels. Using this, instead of the OpenDoors function, so that they open simultaneously
            $('.s3lock, .panel0, .panel1, .panel2, .panel3, .panel4, .panel5, .panel6, .panel7').addClass('open');
        });
        
        //Hide all character bios
        $('#roger-newton-bio, #carson-kipling-bio, #salem-shrike-bio, #sigfried-shrike-bio, #blue-5-bio, #doc-lieber-bio').hide();
        $('.story-template').hide();

        //Hide all comics
        $('#comics, #transmission1, #transmission2, #transmission3').hide();

        //Show storyboard doors and add the sb-open class to the panels
        $('.sb-doors').show();
        $('.sb-panel0, .sb-panel1, .sb-panel2, .sb-panel3, .sb-panel4, .sb-panel5, .sb-panel6, .sb-panel7').addClass('sb-open');
    };

    SWIC6Desktop.prototype.changeStoryboardCharacter = function (character) {
        this.track('crew-log', character, null, 0);

        var characterDiv = '#' + character + '-bio';

        //Hide all user profiles first
        $('#roger-newton-bio, #carson-kipling-bio, #salem-shrike-bio, #sigfried-shrike-bio, #blue-5-bio, #doc-lieber-bio').hide();
        setTimeout(function () {
            $(".profile-summary, .profile-description").scrollTop(0);
        }, 1);

        //Hide doors
        $('.sb-doors').hide();

        //Show story template div
        $('.story-template').show();

        //Show character div
        $(characterDiv).show();
    };

    SWIC6Desktop.prototype.ShowComic = function (comic) {
        if (comic === 'transmission1') {
            $('#t1-page-cover-0').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-0.jpg');
            $('#t1-page-cover-1').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page1.jpg');
            $('#t1-page-cover-2').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page2.jpg');
            $('#t1-page-cover-3').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page3.jpg');
            $('#t1-page-cover-4').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page4.jpg');
            $('#t1-page-cover-5').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page5.jpg');
            $('#t1-page-cover-6').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page6.jpg');
            $('#t1-page-cover-7').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page7.jpg');
            $('#t1-page-cover-8').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page8.jpg');
            $('#t1-page-cover-9').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page9.jpg');
            $('#t1-page-cover-10').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t1-page10.jpg');
        } else if (comic === 'transmission2') {
            $('#t2-page-cover-0').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-0.png');
            $('#t2-page-cover-1').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page1.png');
            $('#t2-page-cover-2').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page2.png');
            $('#t2-page-cover-3').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page3.png');
            $('#t2-page-cover-4').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page4.png');
            $('#t2-page-cover-5').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page5.png');
            $('#t2-page-cover-6').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page6.png');
            $('#t2-page-cover-7').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page7.png');
            $('#t2-page-cover-8').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page8.png');
            $('#t2-page-cover-9').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t2-page9.png');
        } else if (comic === 'transmission3') {
            $('#t3-page-cover-0').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-0.jpg');
            $('#t3-page-cover-1').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page1.jpg');
            $('#t3-page-cover-2').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page2.jpg');
            $('#t3-page-cover-3').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page3.jpg');
            $('#t3-page-cover-4').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page4.jpg');
            $('#t3-page-cover-5').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page5.jpg');
            $('#t3-page-cover-6').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page6.jpg');
            $('#t3-page-cover-7').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page7.jpg');
            $('#t3-page-cover-8').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page8.jpg');
            $('#t3-page-cover-9').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page9.jpg');
            $('#t3-page-cover-10').attr('src', '/content/images/asmo/2015swic/storyboard/comics/t3-page10.jpg');
        }

        $('.door').hide();
        $('.sb-doors').hide();
        $('#transmission1, #transmission2, #transmission3, #transmission1-pages, #transmission2-pages, #transmission3-pages').hide();
        $('#' + comic + ' > .page-selector').show();
        $('#comics, #' + comic).show();
    };

    SWIC6Desktop.prototype.goToComicPage = function (comic, page) {
        this.track(comic, page, null, 0);
        $('.back-button > img, .next-button > img').show(); //Show the back and next button by default
        $('#' + comic + ' > .page-selector').hide(); //hide the page selector
        $('#' + comic + '-pages').show(); //Show the transmission pages div

        var urlTemplate = '/content/images/asmo/2015swic/storyboard/comics/full/t' + comic.substr(comic.length - 1) + '-page';
        var urlExtention = '.png';

        var imgUrl = urlTemplate + page + urlExtention; //Builds the image url
        var comicDiv = $('#' + comic + '-pages > .comic-col > .active-slide');
        var imgSelector = $('#' + comic + '-pages > .comic-col > .active-slide > img');
        var pageCount = comicDiv.attr('data-page-count');

        if (page === 0) $('.back-button > img').hide(); //Hides back button
        if (pageCount == page) $('.next-button > img').hide(); //Hides next button, if this is the last slide

        comicDiv.attr('data-slide-number', page.toString());
        imgSelector.attr('src', imgUrl);

        setTimeout(function () {
            $('#' + comic + ' > .transmission-pages').focus();
            $(".active-slide").scrollTop(0);
        }, 1)
    };

    SWIC6Desktop.prototype.comicNextSlide = function (comic) {
        var self = this;

        var comicDiv = $('#' + comic + '-pages > .comic-col > .active-slide');
        var slideNumber = comicDiv.attr('data-slide-number');
        var nextSlideNumber = parseInt(slideNumber) + 1;
        var pageCount = comicDiv.attr('data-page-count');

        if (pageCount == slideNumber) return;

        self.goToComicPage(comic, nextSlideNumber);
    };

    SWIC6Desktop.prototype.comicPreviousSlide = function (comic) {
        var self = this;

        var comicDiv = $('#' + comic + '-pages > .comic-col > .active-slide');
        var slideNumber = comicDiv.attr('data-slide-number');
        var previousSlideNumber = parseInt(slideNumber) - 1;

        if (slideNumber == 0) return;

        self.goToComicPage(comic, previousSlideNumber);
    };



    return SWIC6Desktop;
}());

IREP.SWIC6EarlyRegistration = (function () {

    var SWIC6EarlyRegistration = function () {
        var self = this;

        $("#footer").remove();
        $("#earlyRegistration").show();

        $("input[name='position']").change(function () {
            if ($("#positionGM:checked").length > 0) {
                $(".thanksGM").show();
            } else {
                $(".thanksGM").hide();
            }

            if ($("#positionDM:checked").length > 0) {
                $(".thanksDM").show();
            } else {
                $(".thanksDM").hide();
            }

            if ($("#positionAU:checked").length > 0) {
                $(".thanksAU").show();
            } else {
                $(".thanksAU").hide();
            }

        });

        IREP.callApi({
            url: "swic6/managerinfo",
            type: "GET"
        }).done(function (d) {
            if (!d.info) {
                $("#chkGM").one("click", function () {
                    if ($("#chkGM:checked").length > 0) {

                        IREP.callApi({
                            url: "swic6/managerinfo",
                            type: "POST",
                            data: { position: "GM" }
                        }).done();
                        self.disableForGM();
                        self.setupSchoolNominations();
                    }
                });

                $("#chkDM").one("click", function () {
                    if ($("#chkDM:checked").length > 0) {
                        IREP.callApi({
                            url: "swic6/managerinfo",
                            type: "POST",
                            data: { position: "DM" }
                        }).done();
                        self.disableForDM();
                        self.setupSchoolNominations();
                    }
                });

                $("#managerInfoSubmit").one("click", function () {
                    self.submitAU();
                });

            } else {
                if (d.info.position == "GM") {
                    self.disableForGM();
                    $("#chkGM, #positionGM").attr("checked", true);
                } else if (d.info.position == "DM") {
                    self.disableForDM();
                    $("#chkDM, #positionDM").attr("checked", true);
                } else if (d.info.position == "AU") {
                    self.disableForAU();
                    document.getElementById("managerEmail").value = d.info.managerEmail;
                    document.getElementById("managerName").value = d.info.managerName;
                    $("#positionAU").attr("checked", true);
                }
                self.setupSchoolNominations();
            }
        });

    };

    SWIC6EarlyRegistration.prototype.disableForGM = function () {
        document.getElementById("chkGM").disabled = true;
        $("#positionDM").parent().remove();
        $("#positionAU").parent().remove();
        $("#thanksGM").show();
        $(".thanksGM").show();
    };

    SWIC6EarlyRegistration.prototype.disableForDM = function () {
        document.getElementById("chkDM").disabled = true;
        $("#positionAU").parent().remove();
        $("#positionGM").parent().remove();
        $("#thanksDM").show();
        $(".thanksDM").show();
    };

    SWIC6EarlyRegistration.prototype.disableForAU = function () {
        document.getElementById("chkDM").disabled = true;
        $("#positionDM").parent().remove();
        $("#positionGM").parent().remove();
        $("#managerName, #managerEmail").attr("disabled", true);
        $("#managerInfoSubmit").hide();
        $(".thanksAU").show();
    };

    SWIC6EarlyRegistration.prototype.submitAU = function () {
        var self = this;
        if (self.validateManagerInfo()) {
            self.disableForAU();

            IREP.callApi({
                url: "swic6/managerinfo",
                type: "POST",
                data: { position: "AU", managerName: document.getElementById("managerName").value, managerEmail: document.getElementById("managerEmail").value }
            }).done();

            self.setupSchoolNominations();
        } else {
            $("#managerInfoSubmit").one("click", function () {
                self.submitAU();
            });
        }

    }

    SWIC6EarlyRegistration.prototype.validateManagerInfo = function () {

        var errors = 0;
        var rg = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;

        if (document.getElementById("managerEmail").value.match(rg) == null) {
            errors += 1;
            document.getElementById("managerEmail").style.border = "solid 1px red";
        } else {
            document.getElementById("managerEmail").style.border = "";
        }

        if (document.getElementById("managerName").value == "") {
            errors += 1;
            document.getElementById("managerName").style.border = "solid 1px red";
        } else {
            document.getElementById("managerName").style.border = "";
        }

        if (errors > 0) {
            return false;
        } else {
            return true;
        }
    }

    SWIC6EarlyRegistration.prototype.setupSchoolNominations = function () {
        var self = this;

        IREP.callApi({
            url: "swic6/schoolnominations",
            type: "GET"
        }).done(function (d) {

            if (d.schools) {
                $(d.schools).each(function () {
                    $("#nominatedSchools").append("<li>" + this.name + " " + this.city + ", " + this.state + "</li>");
                });

                if (d.schools.length > 4) {
                    $("#newNominations").hide();
                } else if (d.schools.length == 0) {
                    $("#schoolsNominated").hide();
                }
            }

            $("#schoolNominations, #schoolNav").show();

            $("#submitNomination").on("click", function () {
                self.submitSchoolNomination();
            });
        });

    }

    SWIC6EarlyRegistration.prototype.submitSchoolNomination = function () {
        var self = this;

        if (self.validateSchoolNomination()) {
            IREP.callApi({
                url: "swic6/schoolnominations",
                type: "POST",
                data: { school: document.getElementById("schoolName").value, city: document.getElementById("schoolCity").value, state: document.getElementById("schoolState").value }
            }).done(function (d) {

                if (d.schools) {
                    $('#nominatedSchools li').remove();
                    $(d.schools).each(function () {
                        $("#nominatedSchools").append("<li>" + this.name + " " + this.city + ", " + this.state + "</li>");
                    });

                    if (d.schools.length > 4) {
                        $("#newNominations").hide();
                    }

                    $("#schoolsNominated").show();

                    document.getElementById("schoolName").value = "";
                    document.getElementById("schoolCity").value = "";
                    document.getElementById("schoolState").value = "";
                }
            });
        }

    }

    SWIC6EarlyRegistration.prototype.validateSchoolNomination = function () {

        var errors = 0;

        if (document.getElementById("schoolName").value == "") {
            errors += 1;
            document.getElementById("schoolName").style.border = "solid 1px red";
        } else {
            document.getElementById("schoolName").style.border = "";
        }

        if (document.getElementById("schoolCity").value == "") {
            errors += 1;
            document.getElementById("schoolCity").style.border = "solid 1px red";
        } else {
            document.getElementById("schoolCity").style.border = "";
        }

        if (document.getElementById("schoolState").value == "") {
            errors += 1;
            document.getElementById("schoolState").style.border = "solid 1px red";
        } else {
            document.getElementById("schoolState").style.border = "";
        }

        if (errors > 0) {
            return false;
        } else {
            return true;
        }
    }

    return SWIC6EarlyRegistration;
}());